import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { CheckIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import { colorTextAction } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { TYPE_EXACT_STRING, TYPE_INCLUSIVE_STRING } from './constants';
import { useETEditorViewportOffset } from '../../../../../hooks';
import { TextButton } from '../../text_button';
const ruleTypeLabel = type => {
  switch (type) {
    case TYPE_INCLUSIVE_STRING:
      return I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.add_meeting_exception.dropdown.include_label');
    case TYPE_EXACT_STRING:
      return I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.add_meeting_exception.dropdown.matching_exactly_label');
    default:
      return '';
  }
};
const containerCss = "c1klbvvu";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const checkIconWrapperCss = "c1oksmi1";
const CheckIconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(checkIconWrapperCss, props.className)} />;
});
const RuleTypeItem = ({
  ruleType,
  value,
  onChange
}) => {
  const isCurrentValue = value === ruleType;
  return <Item onClick={() => onChange(ruleType)}>
      {ruleTypeLabel(ruleType)}
      {isCurrentValue && <CheckIconWrapper>
          <CheckIcon color={colorTextAction} />
        </CheckIconWrapper>}
    </Item>;
};
export const RuleTypeDropdown = ({
  value,
  onChange
}) => {
  const [toggle, Dropdown, isOpen] = useDropdown();
  const viewportOffset = useETEditorViewportOffset();
  return <Container>
      <TextButton isOpen={isOpen} onClick={toggle}>
        {ruleTypeLabel(value)}
      </TextButton>
      <Dropdown>
        <ViewportDropdownMenu viewportOffset={viewportOffset}>
          <RuleTypeItem ruleType={TYPE_EXACT_STRING} value={value} onChange={onChange} />
          <RuleTypeItem ruleType={TYPE_INCLUSIVE_STRING} value={value} onChange={onChange} />
        </ViewportDropdownMenu>
      </Dropdown>
    </Container>;
};

require("./rule_type_dropdown.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./rule_type_dropdown.js");